export default __webpack_public_path__ + "static/logo-09a03f95a8cbac087e1ff58300e65d72.png";